import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { withTranslation } from 'react-i18next';
import Card from '4ff-lib-foundation/lib/components/Card';
import Search from 'prizm-icons/lib/12px/Input/Search';
import BreadcrumbsItem from '../BreadcrumbsItem';
import history from '../../services/history';
import {
  Container,
  Button,
  MDSContent,
  MDSIcon,
  MDSTitle,
  MDSDescription,
  MDSHint,
  MDSButtonGroup,
} from './styles';

const PeriscopeNotFoundIcon = (
  <Search
    width={80}
    height={80}
    color="#3b73b3"
  />
);

class PageNotFound extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    theme: PropTypes.object.isRequired,
  };

  componentDidMount() {
    document.title = this.props.t('LPBD.notFoundPage.breadcrumbsLabel');
  }

  handleReturnHomeBtn = () => {
    history.push('/dashboard');
  };

  getActions = () => ([
    <Button
      mode="inline"
      variant="secondary"
      title={this.props.t('LPBD.notFoundPage.homeBtn')}
      onClick={this.handleReturnHomeBtn}
    />,
  ])

  getMDSContent = () => {
    const actions = this.getActions();
    return (
      <MDSContent>
        <MDSIcon />
        <MDSTitle>{this.props.t('LPBD.notFoundPage.title')}</MDSTitle>
        <MDSDescription>{this.props.t('LPBD.notFoundPage.description')}</MDSDescription>
        {!!actions.length && // eslint-disable-line
          <MDSButtonGroup>{React.Children.toArray(actions)}</MDSButtonGroup>}
        <MDSHint>{this.props.t('LPBD.notFoundPage.hint')}</MDSHint>
      </MDSContent>
    );
  }

  getPeriscopeContent = () => (
    <Card
      icon={PeriscopeNotFoundIcon}
      title={this.props.t('LPBD.notFoundPage.title')}
      description={this.props.t('LPBD.notFoundPage.description')}
      actions={this.getActions()}
    />
  )

  render() {
    return (
      <Container>
        <BreadcrumbsItem to="/dashboard">
          {this.props.t('LPBD.notFoundPage.breadcrumbsLabel')}
        </BreadcrumbsItem>
        {this.props.theme.name === 'mds'
          ? this.getMDSContent()
          : this.getPeriscopeContent()}
      </Container>
    );
  }
}

const TranslatedPageNotFound = withTranslation()(PageNotFound);
export default withTheme(TranslatedPageNotFound);
